/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFigmaIcon16Light = forwardRef('LogoFigmaIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 6.5c-.607.456-1 1.182-1 2 0 .818.393 1.544 1 2a2.5 2.5 0 1 0 4 2v-2a2.5 2.5 0 0 0 3-4A2.5 2.5 0 0 0 10.5 2h-4A2.5 2.5 0 0 0 5 6.5ZM9 3v3h1.5a1.5 1.5 0 0 0 0-3H9ZM8 7H6.5a1.5 1.5 0 1 0 0 3H8V7ZM6.5 6H8V3H6.5a1.5 1.5 0 1 0 0 3ZM5 12.5A1.5 1.5 0 0 1 6.5 11H8v1.5a1.5 1.5 0 0 1-3 0Zm5.5-2.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" })));
});
